export default "__VITE_ASSET__D0ckoYy9__"